export default __webpack_public_path__ + "static/media/2718.5fd3487f.png";